// This file is automatically generated during the release process
// Do not edit manually - it will be overwritten
export const VERSION = "1.3.26";
